import MainLayout from '@/common/components/layouts/MainLayout';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import Stepper from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper';
import { OwnerStepsData } from '@/modules/adjusterReportModules/IncidentParticipants/data/ownerStepsData';
import {
  GetOwnerInformationQueryResponseType,
  IOwnerInformationForm,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitOwnerInformation/getInitialVisitOwnerInformationQuery.type';
import { getInitialVisitOwnerInformationQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitOwnerInformation/getInitialVisitOwnerInformationQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { PropsWithChildren, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation, useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default ({ children }: PropsWithChildren) => {
  return (
    <MainLayout title="بیمه گذار - مالک" header="closeHeader" hasBottomPadding>
      <InitialVisitOwnerInfo>{children}</InitialVisitOwnerInfo>
    </MainLayout>
  );
};
const InitialVisitOwnerInfo = ({ children }: PropsWithChildren) => {
  const { id } = useParams();
  const { data: ownerInformation } = useQuery(
    getInitialVisitOwnerInformationQueryOptions({ id: +id! }),
  );
  const path = useLocation();
  const methods = useForm<IOwnerInformationForm>({ mode: 'onChange' });

  useEffect(() => {
    if (ownerInformation) {
      methods.reset({
        ...ownerInformation,
        personal_information: {
          ...ownerInformation?.originData.personal_information,
          birthdate:
            ownerInformation?.originData.personal_information?.birthdate.toString(),
          owner_type:
            ownerInformation?.originData.personal_information?.owner_type.const,
          gender:
            ownerInformation?.originData.personal_information?.gender.const,
        },
        contact_information: {
          ...ownerInformation?.originData?.contact_information,
        },
      });

      type MainKey = keyof GetOwnerInformationQueryResponseType;
      type SubKey<K extends MainKey> =
        keyof GetOwnerInformationQueryResponseType[K];
      Object.entries(ownerInformation.originData).forEach(([key, inner]) => {
        type K = typeof key extends MainKey ? typeof key : never;

        Object.entries(inner).forEach(([key2, value]) => {
          type K2 = typeof key2 extends SubKey<K> ? typeof key2 : never;

          if (value) {
            setTimeout(() => {
              methods.trigger(`${key}.${key2}` as `${K}.${K2}`);
            }, 500);
          }
        });
      });
    }
  }, [ownerInformation, path.pathname]);
  return (
    <>
      <Box width="100%" pt={'24px'}>
        <Stepper steps={OwnerStepsData} width="80%" />
      </Box>
      <Box
        w="100%"
        mx="auto"
        mt={40}
        mb={24}
        border="1px solid"
        borderColor="gray-2"
      ></Box>
      <Box width="100%">
        <FormProvider {...methods}>{children}</FormProvider>
      </Box>
      <ImagesFabMainModal state="initial" />
    </>
  );
};
